import { Ticket, RotateCcw } from "lucide-react";
import { useLabelsToday, resetLabelsToday } from "@/lib/labelCounter";

// Compact, glanceable tally of Zebra labels sent from THIS station today.
// Turns amber once a lot of stock has gone through, so an over-print is obvious.
export function LabelsTodayBadge() {
  const n = useLabelsToday();
  const hot = n >= 200;   // a big run has gone through — worth a second look
  return (
    <div
      data-testid="labels-today-badge"
      className={`inline-flex items-center gap-2 rounded-lg border px-3 h-9 text-sm font-semibold transition-colors ${hot ? "border-amber-300 bg-amber-50 text-amber-800" : "border-slate-200 bg-white text-slate-700"}`}
      title="Zebra labels sent from this station today (resets at midnight)"
    >
      <Ticket className={`w-4 h-4 ${hot ? "text-amber-600" : "text-[#B01E28]"}`} />
      <span className="text-[11px] font-mono uppercase tracking-wider text-slate-400">Labels today</span>
      <span data-testid="labels-today-count" className="font-display font-black tabular-nums text-base">{n}</span>
      <button
        data-testid="labels-today-reset"
        onClick={() => { if (window.confirm("Reset today's label tally to 0 for this station?")) resetLabelsToday(); }}
        className="ml-0.5 text-slate-400 hover:text-slate-700 transition-colors"
        title="Reset the tally (e.g. at shift start)"
      >
        <RotateCcw className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
